<template>
    <div style="height: 500px;">
        <el-dialog :title="titleName" :visible.sync="dialogFormVisible" class="qazqaz" width="70%">
            <div id="printPzId" style="border: 1px solid #ddd;text-align: center;margin: 10px;padding: 20px">
                <table width="100%" v-for="item in pzzList" :id="item.id">
                    <thead>
                    <tr>
                        <td align="center" colspan="24" style="font: 28px/1.8 Microsoft Yahei;border-bottom: 0px;">
                            记账凭证
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style="padding: 10px;border-top: 0px;" colspan="24">
                            凭证字：{{item.pzz}}{{item.pzhStr}}号 <span
                                style="margin-left: 10px;">日期：{{item.pzDate}}</span></td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #ddd" align="center" width="35%" rowspan="2">摘要</td>
                        <td style="border: 1px solid #ddd" align="center" width="25%" rowspan="2">会计科目</td>
                        <td style="border: 1px solid #ddd;border-right: 1px solid #96a6ac" align="center" width="20%"
                            colspan="11">借方金额
                        </td>
                        <td style="border: 1px solid #ddd" align="center" width="20%" colspan="11">贷方金额</td>
                    </tr>
                    <tr style="border: 1px solid #ddd">
                        <td style="border: 1px solid #ddd" align="center">亿</td>
                        <td style="border: 1px solid #ddd" align="center">千</td>
                        <td style="border: 1px solid #ddd;border-right: 2px solid #c3ddeb" align="center">百</td>
                        <td style="border: 1px solid #ddd" align="center">十</td>
                        <td style="border: 1px solid #ddd" align="center">万</td>
                        <td style="border: 1px solid #ddd;border-right: 2px solid #c3ddeb" align="center">千</td>
                        <td style="border: 1px solid #ddd" align="center">百</td>
                        <td style="border: 1px solid #ddd" align="center">十</td>
                        <td style="border: 1px solid #ddd;border-right: 2px solid #e8cccc" align="center">元</td>
                        <td style="border: 1px solid #ddd" align="center">角</td>
                        <td style="border: 1px solid #ddd;border-right: 1px solid #96a6ac" align="center">分</td>

                        <td style="border: 1px solid #ddd" align="center">亿</td>
                        <td style="border: 1px solid #ddd" align="center">千</td>
                        <td style="border: 1px solid #ddd;border-right: 2px solid #c3ddeb" align="center">百</td>
                        <td style="border: 1px solid #ddd" align="center">十</td>
                        <td style="border: 1px solid #ddd" align="center">万</td>
                        <td style="border: 1px solid #ddd;border-right: 2px solid #c3ddeb" align="center">千</td>
                        <td style="border: 1px solid #ddd" align="center">百</td>
                        <td style="border: 1px solid #ddd" align="center">十</td>
                        <td style="border: 1px solid #ddd;border-right: 2px solid #e8cccc" align="center">元</td>
                        <td style="border: 1px solid #ddd" align="center">角</td>
                        <td style="border: 1px solid #ddd" align="center">分</td>
                    </tr>
                    </thead>
                    <tbody style="border: 1px solid #ddd;">

                    </tbody>

                    <tfoot style="border: 1px solid #ddd;">

                    </tfoot>

                </table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="handlePrint()">打 印</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import $ from 'jquery'
    import "@/plugins/pingzheng/stylecopy.css";

    export default {
        data() {
            return {
                dialogFormVisible: true,
                pzzList: [],
                titleName: '',
                pzDate: null,
                pzh: "",
                pzz: ""

            };
        },
        methods: {
            int(printRow) {
                this.dialogFormVisible = true;
                this.pzDate = null;
                this.pzh = '';
                this.pzzList = [];

                this.titleName = "凭证打印";

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/printView'),
                    method: 'post',
                    data: printRow
                }).then(r => {
                    this.pzzList = r.data.data;

                    console.log(this.pzzList)
                    this.$nextTick(() => {
                        for (let p = 0; p < this.pzzList.length; p++) {
                            let json = this.pzzList[p];
                            let array = json.childList;
                            $("#" + json.id + " tbody").empty();
                            $("#" + json.id + " tfoot").empty();
                            for (let i = 0; i < array.length; i++) {
                                this.vdEdit(json.id, array[i]);
                            }
                            //结算合计
                            this.jieDaiMoney(json.id);
                        }
                    })
                })

            },
            vdEdit(pzId, dataObj) {
                let trObj = `<tr style="border: 1px solid #ddd">

                            <td style="border: 1px solid #ddd;height:20px;padding-left: 10px;" align="left">` + (dataObj.zyJl == null ? '' : dataObj.zyJl) + `</td>
                            <td style="border: 1px solid #ddd;height:20px;padding-left: 10px;" align="left">` + (dataObj.kmdm == null ? '' : dataObj.kmdm) + ' ' + (dataObj.kmmc == null ? '' : dataObj.kmmc) + (dataObj.xmNames == null ? '' : dataObj.xmNames) + `</td>`;

                let jfje = dataObj.jfje;
                if (jfje == null) {
                    jfje = '';
                }
                jfje = (jfje + "").split("").reverse().join("");

                let array = jfje.split("");
                for (let i = 10; i >= 0; i--) {

                    let br = ``;
                    if (i == 8 || i == 5) {
                        br = `border-right: 2px solid #c3ddeb;`;
                    }
                    if (i == 2) {
                        br = `border-right: 2px solid #e8cccc;`;
                    }
                    if (i == 0) {
                        br = `border-right: 1px solid #96a6ac;`;
                    }

                    let classData = '';
                    if (i == 10) {
                        classData = 'class = "v-money" dataval="' + (dataObj.jfje == null ? '' : dataObj.jfje) + '" ';
                    }

                    if (array.length < i + 1) {
                        trObj += `<td ` + classData + ` style="border: 1px solid #ddd;` + br + `" align="center"></td>`;
                    } else {
                        trObj += `<td ` + classData + ` style="border: 1px solid #ddd;` + br + `" align="center">` + array[i] + `</td>`;
                    }
                }

                let dfje = dataObj.dfje;
                if (dfje == null) {
                    dfje = '';
                }
                dfje = (dfje + "").split("").reverse().join("");

                array = dfje.split("");
                for (let i = 10; i >= 0; i--) {

                    let br = ``;
                    if (i == 8 || i == 5) {
                        br = `border-right: 2px solid #c3ddeb;`;
                    }
                    if (i == 2) {
                        br = `border-right: 2px solid #e8cccc;`;
                    }

                    let classData = '';
                    if (i == 10) {
                        classData = 'class = "v-money v-money2" dataval = "' + (dataObj.dfje == null ? '' : dataObj.dfje) + '" ';
                    }

                    if (array.length < i + 1) {
                        trObj += `<td ` + classData + ` style="border: 1px solid #ddd;` + br + `" align="center"></td>`;
                    } else {
                        trObj += `<td ` + classData + ` style="border: 1px solid #ddd;` + br + `" align="center">` + array[i] + `</td>`;
                    }
                }


                trObj += `</tr>`;
                $("#" + pzId + " tbody").append(trObj);
            },
            jieDaiMoney(pzId) {
                let jieMoney = 0;
                let daiMoney = 0;
                $.each($("#" + pzId + " tbody .v-money"), function (i, obj) {
                    let dVal = $(obj).attr("dataval");
                    if ($(obj).hasClass("v-money2")) {
                        if (dVal != "" && dVal != null && dVal != 'null') {
                            daiMoney += parseFloat(dVal);
                        }
                    } else {
                        if (dVal != "" && dVal != null && dVal != 'null') {
                            jieMoney += parseFloat(dVal);
                        }
                    }
                });

                let hjText = '不平';
                if (jieMoney == daiMoney) {
                    hjText = intToChinese(jieMoney)
                }

                this.addTfoot(pzId, hjText, jieMoney, daiMoney);
            },
            addTfoot(pzId, hjText, jfje, dfje) {
                let trObj = `<tr style="border: 1px solid #ddd">
                            <td style="border: 1px solid #ddd;height:20px;padding-left: 10px;" colspan="2" align="left">合计：` + hjText + `</td>`;

                if (jfje == null) {
                    jfje = '';
                }
                jfje = (jfje + "").split("").reverse().join("");

                let array = jfje.split("");
                for (let i = 10; i >= 0; i--) {

                    let br = ``;
                    if (i == 8 || i == 5) {
                        br = `border-right: 2px solid #c3ddeb;`;
                    }
                    if (i == 2) {
                        br = `border-right: 2px solid #e8cccc;`;
                    }
                    if (i == 0) {
                        br = `border-right: 1px solid #96a6ac;`;
                    }

                    let classData = '';
                    if (1 == 10) {
                        classData = 'class = "v-money" dataVal="' + dataObj.jfje + '"';
                    }

                    if (array.length < i + 1) {
                        trObj += `<td ` + classData + ` style="border: 1px solid #ddd;` + br + `" align="center"></td>`;
                    } else {
                        trObj += `<td ` + classData + ` style="border: 1px solid #ddd;` + br + `" align="center">` + array[i] + `</td>`;
                    }
                }

                if (dfje == null) {
                    dfje = '';
                }
                dfje = (dfje + "").split("").reverse().join("");

                array = dfje.split("");
                for (let i = 10; i >= 0; i--) {

                    let br = ``;
                    if (i == 8 || i == 5) {
                        br = `border-right: 2px solid #c3ddeb;`;
                    }
                    if (i == 2) {
                        br = `border-right: 2px solid #e8cccc;`;
                    }

                    let classData = '';
                    if (1 == 10) {
                        classData = 'class = "v-money v-money2" dataVal="' + dataObj.jfje + '"';
                    }

                    if (array.length < i + 1) {
                        trObj += `<td ` + classData + ` style="border: 1px solid #ddd;` + br + `" align="center"></td>`;
                    } else {
                        trObj += `<td ` + classData + ` style="border: 1px solid #ddd;` + br + `" align="center">` + array[i] + `</td>`;
                    }
                }


                trObj += `</tr>`;
                $("#" + pzId + " tfoot").append(trObj);
            },
            intToChinese(n) {
                n += '';
                if (!/^(-?[0-9]\d*)$/.test(n))
                    return "——";
                if (n * 1 == 0) {
                    return '零元整';
                }
                let fu = "";
                if (n * 1 < 0) {
                    fu = "负";
                    n = n.substring(1);
                }
                let unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
                    str = "";
                unit = unit.substr(unit.length - n.length);
                for (let i = 0; i < n.length; i++)
                    str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
                let str1 = str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
                return fu + str1;
            },
            handlePrint() {
                let printMe = document.querySelector('#printPzId');
                let printContent = printMe.innerHTML;
                let windowContent = document.createElement('div');
                windowContent.appendChild(document.importNode(printMe.cloneNode(true), true));
                let printWindow = window.open('', '_blank');
                printWindow.document.open();
                printWindow.document.write('<html><head><title>打印</title>');
                printWindow.document.write('</head><body>');
                printWindow.document.write(windowContent.innerHTML);
                printWindow.document.write('</body></html>');
                printWindow.document.close();
                printWindow.onload = function () {
                    printWindow.print();
                    printWindow.close();
                };
            }
        },
        mounted() {
            window.jieDaiMoney = this.jieDaiMoney;// 方法赋值给window
            window.intToChinese = this.intToChinese;
        }
    }
</script>

<style scoped>
    .viewVcloud-main-body-B {
        overflow: hidden;
        overflow-y: auto;
        -o-transition: all 0.2s ease;
        -ms-transition: all 0.2s ease;
        -moz-transition: all 0.2s ease;
        -webkit-transition: all 0.2s ease;
        margin: 10px 5px;
        height: 520px;
    }

    .qazqaz >>> .el-dialog__body {
        padding: 0px !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }

    .common-dialog >>> .el-dialog__body {
        padding: 10px !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }
    /deep/ .el-dialog {
        height: 100vh;
        overflow: auto;
    }
</style>
